import { useEffect, useState } from "react";
import { Branding, loadBranding } from "utils/branding";

export function useBranding() {
  const [branding, setBranding] = useState<Branding | null>(null);

  useEffect(() => {
    let active = true;
    loadBranding().then((data) => {
      if (active) setBranding(data);
    });
    return () => {
      active = false;
    };
  }, []);

  return branding;
}
